import { useUser } from '@core/user';
import { useMutation, UseMutationConfig } from '@libs/use';
import {
  CreateVirtualPortfolioItemRequest,
  CreateVirtualPortfolioItemResponse,
} from '@libs/api-reference';

import * as API from '../../requests';

type UseCreateVirtualPortfolioItemOptions = {
  onReject?: UseMutationConfig<object>['onReject'];
  onSuccess?: UseMutationConfig<CreateVirtualPortfolioItemResponse>['onSuccess'];
};

export default function useCreateVirtualPortfolioItemQuery({
  onReject,
  onSuccess,
}: UseCreateVirtualPortfolioItemOptions) {
  const { user } = useUser();

  const {
    execute: createVirtualPortfolioItem,
    isPending: isLoadingCreateVirtualPortfolioItem,
    ...query
  } = useMutation<CreateVirtualPortfolioItemResponse>(
    ({
      quantity,
      instrumentIsin,
      averagePrice,
    }: CreateVirtualPortfolioItemRequest) =>
      API.createVirtualPortfolio({
        averagePrice,
        quantity,
        instrumentIsin,
        investorBourseCodeId: user.value?.investorBourseCodes[0].id as number,
      }),
    {
      onSuccess,
      onReject,
    }
  );

  return {
    createVirtualPortfolioItem,
    isLoadingCreateVirtualPortfolioItem,
    ...query,
  };
}
